// Centralized site data for BTW
export const ORDER_URL = "https://www.grubhub.com/restaurant/burgers-tacos-wings--seafood-110-46-merrick-blvd-jamaica/2508348";

export const NAV_LINKS = [
  { label: "MENU", href: "/menu" },
  { label: "CATERING", href: "/#catering" },
  { label: "ORDER NOW", href: ORDER_URL, external: true, accent: true },
  { label: "LOCATIONS", href: "/#footer" },
  { label: "CONTACT", href: "/#footer" },
];

export const HERO_IMAGE = "/hero/btw-spread.jpg";

export const GRILL_IMAGE =
  "https://images.pexels.com/photos/1233101/pexels-photo-1233101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export const POPULAR_COMBOS = [
  {
    id: "5-fries",
    name: "5 & Fries",
    desc: "5 Wings or 5 Shrimp · Fries + Can Drink",
    price: "$9.99",
    badge: "Best Value",
    img: "/combos/btw-5-fries.jpg",
  },
  {
    id: "3-tacos",
    name: "3 Tacos Combo",
    desc: "3 Tacos (Beef or Chicken) · Rice + Beans",
    price: "$10.99",
    badge: null,
    img: "/combos/btw-3-tacos-combo.jpg",
  },
  {
    id: "slider",
    name: "Slider Combo",
    desc: "2 Sliders · Fries + Can Drink",
    price: "$11.99",
    badge: null,
    img: "/combos/btw-slider-combo.jpg",
  },
  {
    id: "super",
    name: "BTW Super Combo",
    desc: "5 Wings or Shrimp · 2 Sliders + 2 Tacos",
    price: "$19.99",
    badge: "Most Popular",
    img: "/combos/btw-super-combo.jpg",
  },
];

export const MENU_TABS = {
  Combos: [
    { name: "Burger Meal Deal", price: "$12.99", desc: "Burger + Fries + Drink", img: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=700&q=85" },
    { name: "3 Tacos Combo", price: "$10.99", desc: "3 Tacos + Rice + Beans", img: "https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?auto=format&fit=crop&w=700&q=85" },
    { name: "10 Wings", price: "$14.99", desc: "Fries + Drink", img: "https://images.unsplash.com/photo-1608039755401-742074f0548d?auto=format&fit=crop&w=700&q=85" },
    { name: "OG Bowl", price: "$12.99", desc: "Jerk Chicken Bowl", img: "https://images.pexels.com/photos/14090828/pexels-photo-14090828.jpeg?auto=compress&cs=tinysrgb&w=700" },
    { name: "Big Shrimpin", price: "$14.99", desc: "Garlic Shrimp Bowl", img: "https://images.unsplash.com/photo-1650216650901-71a6fc5fa70c?auto=format&fit=crop&w=700&q=85" },
  ],
  "Bowls & Salads": [
    { name: "OG Jerk Bowl", price: "$12.99", desc: "Jerk Chicken + Rice + Beans", img: "https://images.pexels.com/photos/14090828/pexels-photo-14090828.jpeg?auto=compress&cs=tinysrgb&w=700" },
    { name: "Big Shrimpin Bowl", price: "$14.99", desc: "Garlic Shrimp + Veggies", img: "https://images.unsplash.com/photo-1650216650901-71a6fc5fa70c?auto=format&fit=crop&w=700&q=85" },
    { name: "Crunch Salad", price: "$9.99", desc: "Crispy Chicken + Greens", img: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=700&q=85" },
    { name: "Power Bowl", price: "$11.99", desc: "Quinoa + Grilled Veg + Chicken", img: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=700&q=85" },
    { name: "Veggie Bowl", price: "$10.99", desc: "Black Beans + Rice + Salsa", img: "https://images.unsplash.com/photo-1543339308-43e59d6b73a6?auto=format&fit=crop&w=700&q=85" },
  ],
  Wings: [
    { name: "5 Wings", price: "$8.99", desc: "Choice of Sauce", img: "https://images.unsplash.com/photo-1608039755401-742074f0548d?auto=format&fit=crop&w=700&q=85" },
    { name: "10 Wings", price: "$14.99", desc: "Choice of 2 Sauces", img: "https://images.pexels.com/photos/36782573/pexels-photo-36782573.jpeg?auto=compress&cs=tinysrgb&w=700" },
    { name: "15 Wings", price: "$19.99", desc: "Choice of 3 Sauces", img: "https://images.unsplash.com/photo-1567620832903-9fc6debc209f?auto=format&fit=crop&w=700&q=85" },
    { name: "Boneless Tenders", price: "$11.99", desc: "5 Crispy Tenders", img: "https://images.unsplash.com/photo-1562967914-608f82629710?auto=format&fit=crop&w=700&q=85" },
    { name: "Buffalo Bites", price: "$9.99", desc: "Saucy & Crispy", img: "https://images.unsplash.com/photo-1527477396000-e27163b481c2?auto=format&fit=crop&w=700&q=85" },
  ],
  Seafood: [
    { name: "Garlic Shrimp", price: "$13.99", desc: "Buttery Garlic Shrimp", img: "https://images.unsplash.com/photo-1650216650901-71a6fc5fa70c?auto=format&fit=crop&w=700&q=85" },
    { name: "Fish Tacos", price: "$11.99", desc: "Crispy Fish + Slaw", img: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&w=700&q=85" },
    { name: "Shrimp Basket", price: "$12.99", desc: "Fries + Cocktail Sauce", img: "https://images.unsplash.com/photo-1625938144755-652e08e359b7?auto=format&fit=crop&w=700&q=85" },
    { name: "Cajun Catfish", price: "$13.99", desc: "Spiced & Fried", img: "https://images.unsplash.com/photo-1611599537845-1c7aca0091c0?auto=format&fit=crop&w=700&q=85" },
    { name: "Salmon Bowl", price: "$15.99", desc: "Grilled Salmon + Rice", img: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&w=700&q=85" },
  ],
  "Add-ons": [
    { name: "Crinkle Fries", price: "$3.99", desc: "Golden + Crispy", img: "https://images.unsplash.com/photo-1573080496219-bb080dd4f877?auto=format&fit=crop&w=700&q=85" },
    { name: "Loaded Fries", price: "$6.99", desc: "Cheese + Bacon + Sauce", img: "https://images.unsplash.com/photo-1639024471283-03518883512d?auto=format&fit=crop&w=700&q=85" },
    { name: "Mac & Cheese", price: "$4.99", desc: "Creamy Cheddar", img: "https://images.unsplash.com/photo-1543352634-99a5d50ae78e?auto=format&fit=crop&w=700&q=85" },
    { name: "Coleslaw", price: "$2.99", desc: "Fresh & Tangy", img: "https://images.unsplash.com/photo-1551845041-63e8e76836ea?auto=format&fit=crop&w=700&q=85" },
    { name: "Onion Rings", price: "$4.49", desc: "Beer Battered", img: "https://images.unsplash.com/photo-1639744093327-eb2b8d4c0c01?auto=format&fit=crop&w=700&q=85" },
  ],
  Drinks: [
    { name: "Fountain Drink", price: "$2.49", desc: "Free Refills In-store", img: "https://images.unsplash.com/photo-1581636625402-29b2a704ef13?auto=format&fit=crop&w=700&q=85" },
    { name: "Lemonade", price: "$3.49", desc: "Fresh-Squeezed", img: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=700&q=85" },
    { name: "Iced Tea", price: "$2.99", desc: "Sweet or Unsweet", img: "https://images.unsplash.com/photo-1556679343-c1d2eb19f432?auto=format&fit=crop&w=700&q=85" },
    { name: "Bottled Water", price: "$1.99", desc: "Spring Water", img: "https://images.unsplash.com/photo-1502740479091-635887520276?auto=format&fit=crop&w=700&q=85" },
    { name: "Milkshake", price: "$4.99", desc: "Vanilla · Chocolate · Strawberry", img: "https://images.unsplash.com/photo-1572490122747-3968b75cc699?auto=format&fit=crop&w=700&q=85" },
  ],
};

export const CATERING_ITEMS = [
  {
    name: "20 Wing Sampler",
    sub: "4 Flavors",
    price: "$27.99",
    img: "/catering/btw-20-wing-sampler.jpg",
  },
  {
    name: "50 Wing Pack",
    sub: "Feeds the Crew",
    price: "$59.99",
    img: "https://images.pexels.com/photos/36782573/pexels-photo-36782573.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
  {
    name: "10 Taco Pack",
    sub: "Beef or Chicken",
    price: "$29.99",
    img: "https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?auto=format&fit=crop&w=900&q=85",
  },
  {
    name: "Mixed Party Box",
    sub: "20 Wings · 6 Sliders · 6 Tacos",
    price: "$54.99",
    img: "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?auto=format&fit=crop&w=900&q=85",
  },
];
